import React from 'react'

const Interview_Mock_Test_1A = () => {
  return (
    <div>
      <h1>Mock Test 1</h1>
    </div>
  )
}

export default Interview_Mock_Test_1A
